<div class="server-down-container">
  <div class="error-content">
    @if (companyLogo) {
      <img class="brand-logo" [src]="companyLogo" [alt]="companyName || 'Logo'" />
    }

    <div class="error-icon">
      <i class="pi pi-server" aria-hidden="true"></i>
    </div>

    <h1 class="error-title">Servizio temporaneamente non disponibile</h1>

    <p class="error-message">
      Stiamo riscontrando difficoltà tecniche con i nostri server. Il nostro team è stato informato e sta lavorando per ripristinare il servizio.
    </p>

    <div class="error-details">
      <div class="detail-item">
        <strong>Stato</strong>
        <span class="status-badge"><span class="dot"></span>Non disponibile (503)</span>
      </div>
      <div class="detail-item">
        <strong>Ultimo controllo</strong>
        <span>{{ lastChecked | date : 'medium' }}</span>
      </div>
      @if (isRetrying) {
        <div class="detail-item">
          <strong>Prossimo tentativo</strong>
          <span>{{ nextRetryIn }}s</span>
        </div>
      }
    </div>

    <div class="action-buttons">
      <button class="kcs-btn kcs-btn-primary" (click)="retryConnection()" [disabled]="isRetrying">
        @if (!isRetrying) {
          <span><i class="pi pi-refresh" aria-hidden="true"></i> Riprova</span>
        }
        @if (isRetrying) {
          <span class="loading">
            <span class="spinner"></span>
            Riprovando...
          </span>
        }
      </button>

      <button class="kcs-btn kcs-btn-secondary" (click)="refreshPage()">
        <i class="pi pi-replay" aria-hidden="true"></i> Aggiorna pagina
      </button>
    </div>

    @if (autoRetryEnabled) {
      <div class="auto-retry">
        <span class="auto-retry-info">
          <i class="pi pi-sync" aria-hidden="true"></i>
          Tentativo automatico tra {{ autoRetryCountdown }}s
        </span>
        <button class="disable-auto-retry" (click)="disableAutoRetry()">Disabilita</button>
      </div>
    }

    <div class="contact-info">
      <p class="mb-0">Hai bisogno di assistenza immediata? <a href="mailto:helpdesk@kondorcs.it">Contatta il supporto</a></p>
    </div>
  </div>
</div>
